/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentType,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    if (contentType) {
      payload.append('content_type', contentType);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      content_type: contentType,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentType,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
  }) {
    const isInteractiveMessage = contentType === 'interactive';
    const interactivePayload = contentAttributes?.interactive;
    let interactiveRequestData = {
      interactive: interactivePayload,
      echo_id: echoId,
    };

    if (isInteractiveMessage && files?.length) {
      const formData = new FormData();
      formData.append('interactive', JSON.stringify(interactivePayload));
      formData.append('echo_id', echoId);
      files.forEach(file => {
        formData.append('attachments[]', file);
      });
      interactiveRequestData = formData;
    }

    return axios({
      method: 'post',
      url: isInteractiveMessage
        ? `${this.url}/${conversationId}/messages/interactive`
        : `${this.url}/${conversationId}/messages`,
      data: isInteractiveMessage
        ? interactiveRequestData
        : buildCreatePayload({
            message,
            isPrivate,
            contentType,
            contentAttributes,
            echoId,
            files,
            ccEmails,
            bccEmails,
            toEmails,
            templateParams,
          }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    const shouldFetchMessageRange =
      after && (!before || Number(after) < Number(before));

    if (shouldFetchMessageRange) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  sendToBpo(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/send_to_bpo`
    );
  }

  sendToBpoBulk(conversationId, messageIds) {
    return axios.post(
      `${this.url}/${conversationId}/messages/send_to_bpo_bulk`,
      { message_ids: messageIds }
    );
  }

  searchMessages(conversationId, query) {
    return axios.get(`${this.url}/${conversationId}/messages/search`, {
      params: { q: query },
    });
  }
}

export default new MessageApi();
